import React, { useCallback, useState, useRef } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { GridLayout } from "../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import route from "../../../../assets/apiRoutes.json";
import GridLayoutManager from '../../../../gridLayoutCustomization/GridLayoutManager';
const APIMessagesTab = (props) => {
  const dataGrid = useRef(null);
  const history = useHistory();
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const gridKey = "E21D9465-2DFB-4B54-8386-9B736E3CF035";
  const [currentLayout, setCurrentLayout] = useState("Default");

   const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
   const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);

  const resultData = createStore({
    key: 'rowId',
    loadParams:
    {
      sourceId: function () {
        return props.sourceId;
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${route.APIMessages.GetAPIMessages}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >

            <div>
              <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={resultData}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
              >
                <ColumnChooser
                  enabled={true}
                  title="Choose Column"
                  width={290}
                  height={290}
                  sortOrder="asc"
                >
                  <ColumnChooserSearch
                      enabled={true}
                      editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  showPageSizeSelector={true}
                  allowedPageSizes={allowedPageSizes}
                  showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                  enabled={true}
                  type="custom"
                  customLoad={loadState}
                  storageKey={gridKey}
                  customSave={saveState}
                />
                <Column dataField="module" caption="Module" dataType='string' />
                <Column dataField="operation" caption="Operation" dataType="string" />
                <Column dataField="operationDatetime" caption="Operation Date Time" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                <Column dataField="creationDatetime" caption="Creation Date Time" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                <Column dataField="creationUserId" caption="Created By" dataType="string" />
                <Column dataField="lastUpdateDatetime" caption="Last Update Date Time" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                <Column dataField="lastUpdateUserId" caption="Last Updated User" dataType="string" />
                <Column dataField="itemCode" caption="Item Code" dataType="string" />
                <Column dataField="lotCode" caption="Lot Code" dataType="string" />
                <Column dataField="subLotCode" caption="SubLot Code" dataType="string" />
                <Column dataField="serialNumber" caption="Serial Number" dataType="string" />
                <Column dataField="wareHouseName" caption="Warehouse" dataType="string" />
                <Column dataField="locationCode" caption="Location Code" dataType="string" />
                <Column dataField="quantity" caption="Quantity" dataType="number" />
                <Column dataField="comment" caption="Comment" dataType="string" />


                <GridToolbar>
                  <GridToolbarItem location="after">
                      <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                  </GridToolbarItem>
                  <GridToolbarItem name="exportButton" />
                  <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
              </DataGrid>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(APIMessagesTab);